// src/configs/RoutesConfig.js
import React from 'react';
import { AUTH_PREFIX_PATH, APP_PREFIX_PATH } from 'configs/AppConfig';

export const publicRoutes = [
    {
        key: 'login',
        path: `${AUTH_PREFIX_PATH}/login`,
        component: React.lazy(() => import('views/auth-views/authentication/login')),
    },
    {
        key: 'register',
        path: `${AUTH_PREFIX_PATH}/register`,
        component: React.lazy(() => import('views/auth-views/authentication/register')),
    },
    {
        key: 'forgot-password',
        path: `${AUTH_PREFIX_PATH}/forgot-password`,
        component: React.lazy(() => import('views/auth-views/authentication/forgot-password')),
    },
];

export const protectedRoutes = [
    {
        key: 'dashboard.default',
        path: `${APP_PREFIX_PATH}/dashboards/default`,
        component: React.lazy(() => import('views/app-views/dashboards/default')),
        meta: { roles: ['admin', 'supervisor', 'consulta'] }, // Reportes: lectura para todos
    },
    // ── Sprint 1: Gestión de usuarios ──────────────────────────
    {
        key: 'usuarios',
        path: `${APP_PREFIX_PATH}/usuarios`,
        component: React.lazy(() => import('views/app-views/usuarios')),
        meta: { roles: ['admin'] }, // solo admin puede llegar
    },

    // ── Sprint 2: Gestión de empleados ─────────────────────────
    {
        key: 'empleados',
        path: `${APP_PREFIX_PATH}/empleados`,
        component: React.lazy(() => import('views/app-views/empleados')),
        meta: { roles: ['admin', 'supervisor', 'consulta'] },
    },

    {
        key: 'empresas',
        path: `${APP_PREFIX_PATH}/empresas`,
        component: React.lazy(() => import('views/app-views/empresas')),
        meta: { roles: ['admin', 'supervisor', 'consulta'] }, // igual que EmpresaPolicy::viewAny; creación/edición se restringe dentro de la vista
    },

    // ── Sprint 1: Gestión de geocercas ─────────────────────────
    {
        key: 'geocercas',
        path: `${APP_PREFIX_PATH}/geocercas`,
        component: React.lazy(() => import('views/app-views/geocercas')),
        meta: { roles: ['admin', 'supervisor', 'consulta'] }, // igual que GeocercaPolicy::viewAny; creación/edición/eliminación se restringe dentro de la vista
    },

    // ── Sprint 3: Configuración en cascada ─────────────────────
    {
        key: 'configuracion',
        path: `${APP_PREFIX_PATH}/configuracion`,
        component: React.lazy(() => import('views/app-views/configuracion')),
        meta: { roles: ['admin', 'supervisor', 'consulta'] }, // igual que ConfiguracionPolicy::viewAny; la escritura (solo admin) se restringe dentro de la vista
    },

    // ── Sprint 3: Asistencias / Registros ──────────────────────
    {
        key: 'operacion-asistencias',
        path: `${APP_PREFIX_PATH}/asistencias`,
        component: React.lazy(() => import('views/app-views/asistencias')),
        meta: { roles: ['admin', 'supervisor', 'consulta'] }, // igual que AsistenciaPolicy::viewAny; registro manual/edición/eliminación se restringe dentro de la vista
    },
];